export const titles = ['Mr', 'Mrs', 'Miss', 'Ms', 'Other'];

export const genders = ['Male', 'Female', 'Other'];
